<script setup>
import { useForm } from "@inertiajs/vue3";
import ActionMessage from "../../../Jetstream/ActionMessage.vue";
import FormSection from "../../../Jetstream/FormSection.vue";
import InputError from "../../../Jetstream/InputError.vue";
import InputLabel from "../../../Jetstream/InputLabel.vue";
import PrimaryButton from "../../../Jetstream/PrimaryButton.vue";
import TextInput from "../../../Jetstream/TextInput.vue";

const props = defineProps({
    team: Object,
    permissions: Object,
});

const form = useForm({
    name: props.team.name,
});

const updateTeamName = () => {
    form.put(route("teams.update", props.team), {
        errorBag: "updateTeamName",
        preserveScroll: true,
    });
};
</script>

<template>
    <FormSection @submitted="updateTeamName">
        <template #title>{{
            $t("teams.team_settings.update_team_name.title")
        }}</template>

        <template #description>
            {{ $t("teams.team_settings.update_team_name.description") }}
        </template>

        <template #form>
            <!-- Team Owner Information -->
            <div class="col-span-6">
                <InputLabel
                    :value="
                        $t('teams.team_settings.update_team_name.team_owner')
                    "
                />

                <div class="mt-2 flex items-center">
                    <img
                        class="h-12 w-12 rounded-full object-cover"
                        :src="team.owner.profile_photo_url"
                        :alt="team.owner.name"
                    />

                    <div class="ml-4 leading-tight">
                        <div>{{ team.owner.name }}</div>
                        <div class="text-sm text-iron-700">
                            {{ team.owner.email }}
                        </div>
                    </div>
                </div>
            </div>

            <!-- Team Name -->
            <div class="sm:col-span-4 col-span-6">
                <InputLabel
                    for="name"
                    :value="
                        $t('teams.team_settings.update_team_name.team_name')
                    "
                />

                <TextInput
                    id="name"
                    v-model="form.name"
                    type="text"
                    class="mt-1 block w-full"
                    :disabled="!permissions.canUpdateTeam"
                />

                <InputError :message="form.errors.name" class="mt-2" />
            </div>
        </template>

        <template v-if="permissions.canUpdateTeam" #actions>
            <ActionMessage :on="form.recentlySuccessful" class="mr-3">
                {{ $t("saved") }}
            </ActionMessage>

            <PrimaryButton
                :class="{ 'opacity-25': form.processing }"
                :disabled="form.processing"
            >
                {{ $t("save") }}
            </PrimaryButton>
        </template>
    </FormSection>
</template>
